export default __webpack_public_path__ + "static/media/jobs-icon.4da80d03.svg";